import React, { useState, useRef, useEffect } from "react";
import { Search } from "@mui/icons-material";
import CalendorIcon from "../../../../src/assests/images/calendar-2.svg";
// Removed Plus import since buttons were replaced by dropdown
import { useAlert } from "../../AlertContext/AlertContext";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  Button,
  ListItemText,
  ListItemButton,
  List,
  ButtonGroup,
  CircularProgress,
  Tooltip,
  IconButton,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CloseIcon from '@mui/icons-material/Close';
import { debounce } from "lodash";
import BulkRetailerTable from "./BulkRetailerListTable";
import BulkSFATable from "./BulkSFATable";
import { getSfaData, uploadRewardsSFA, uploadTargetSFA, uploadActualSFA, viewretailersv2, getActivityLogs } from "./api";
import { uploadcsv } from "../../reports/api";
import { getToken } from '../../../utils/utils';
import arrowLeft from "../../../assests/images/arrow-left.svg";
import arrowRight from "../../../assests/images/arrow-right.png";
import doubleArrowLeft from "../../../assests/images/double-arrow-left.svg";
import doubleArrowRight from "../../../assests/images/double-arrow-right.svg";
import { Info } from "@mui/icons-material";
import LogTable, { LogEntry } from "./LogTable";

// ✅ Custom calendar input
const CustomInput = React.forwardRef<HTMLInputElement, any>(
  ({ value, onClick, onClear }, ref) => (
    <div
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        border: "1px solid #ccc",
        backgroundColor: "#fff",
        borderRadius: "10px",
        padding: "0 10px",
        height: "48px",
        width: "301px",
        cursor: "pointer",
      }}
    >
      <input
        ref={ref}
        value={value || "Select Date Range"}
        style={{
          fontSize: "14px",
          border: "none",
          outline: "none",
          flex: 1,
          color: "#000",
          backgroundColor: "transparent",
        }}
        readOnly
        onClick={onClick}
      />
      {value && (
        <CloseIcon
          onClick={(e) => {
            e.stopPropagation(); // prevent triggering the date picker
            onClear(); // call clear handler
          }}
          sx={{ fontSize: 20, cursor: "pointer", marginRight: 1 }}
        />
      )}
      <img
        src={CalendorIcon}
        alt="Calendar Icon"
        style={{ height: "20px", width: "20px", cursor: "pointer" }}
        onClick={onClick}
      />
    </div>
  )
);

// ✅ helper for date format
const formatDate = (date: Date | null) => {
  if (!date) return "";
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const logData: LogEntry[] = [
  {
    id: "1001",
    pmi_entity_codes: "PMI001",
    created_at: "9th Oct 2025, 10:15",
    type: "Retailer",
    description: "Upload successful",
    original_file_name: "retailers.csv",
    status: "Success",
  },
  {
    id: "1002",
    pmi_entity_codes: "PMI002",
    created_at: "9th Oct 2025, 11:00",
    type: "SFA",
    description: "Target upload",
    original_file_name: "sfa_target.xlsx",
    status: "Success",
  },
  {
    id: "1003",
    pmi_entity_codes: "PMI003",
    created_at: "9th Oct 2025, 11:30",
    type: "Retailer",
    description: "Upload failed",
    original_file_name: "retailers_failed.csv",
    status: "Failed",
  },
];

/** ✅ CustomArrow copied from DropDownFilter (design only) */
const CustomArrow = ({ open, onClick }: { open: boolean; onClick: () => void }) => (
  <span
    onClick={(e) => {
      e.stopPropagation();
      onClick();
    }}
    style={{
      display: "inline-block",
      width: "11px",
      height: "8px",
      borderRight: "2px solid #000",
      borderBottom: "2px solid #000",
      transform: open ? "rotate(-135deg)" : "rotate(45deg)",
      transition: "transform 0.2s ease",
      marginLeft: "20px",
      position: "relative",
      right: "10px",
      cursor: "pointer",
    }}
  />
);

function BulkUploads() {
  const [isBulk, setIsBulk] = useState<boolean>(() => {
    const stored = localStorage.getItem("bulkTab")
    console.log("Initial tab from localStorage:", stored);
    return stored === 'SFA' ? true : false
  })
  const [filters, setFilters] = useState<any>({
    lastLogin: null,
    locations: [],
    outlet_type: [],
    startDate: null,
    endDate: null,
  });
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupPosition, setPopupPosition] = useState<{ top: number; left: number }>({
    top: 0,
    left: 0,
  });

  const [activeTab, setActiveTab] = useState(localStorage.getItem("bulkTab") || "retailer");
  const sortButtonRef = useRef<HTMLButtonElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);
  const { showAlert } = useAlert();
  const [totalUsers, setTotalUsers] = useState(0);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);

  const [sfaData, setSfaData] = useState<any[]>([]);
  const [retailerData, setRetailerData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const [startDate, endDate] = dateRange;

  const token = getToken();
  const handleTabChange = (bulk: boolean) => {
    console.log("Tab changed to:", bulk ? "SFA" : "Retailers");
    setIsBulk(bulk);
    localStorage.setItem("bulkTab", String(bulk));
  };
  const formatLogDate = (createdAt: string | Date) => {
    const date = new Date(createdAt);

    const day = date.getDate();
    const suffix =
      day % 10 === 1 && day !== 11
        ? "st"
        : day % 10 === 2 && day !== 12
          ? "nd"
          : day % 10 === 3 && day !== 13
            ? "rd"
            : "th";

    const month = date.toLocaleString("en-US", { month: "short" }); // "Jan", "Feb", "Sep"
    const year = date.getFullYear();

    const hours = date.getHours().toString().padStart(2, "0"); // 0-23
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${day}${suffix} ${month} ${year}, ${hours}:${minutes}`;
  };

  const formatLogDate1 = (createdAt: string | Date) => {
    const date = new Date(createdAt);

    const day = date.getUTCDate();
    const suffix =
      day % 10 === 1 && day !== 11
        ? "st"
        : day % 10 === 2 && day !== 12
          ? "nd"
          : day % 10 === 3 && day !== 13
            ? "rd"
            : "th";

    const month = date.toLocaleString("en-US", {
      month: "short",
      timeZone: "UTC",
    });
    const year = date.getUTCFullYear();

    const hours = date.getUTCHours().toString().padStart(2, "0");
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");

    return `${day}${suffix} ${month} ${year}, ${hours}:${minutes}`;
  };

  const [logData, setLogData] = useState<LogEntry[]>([]);
  const [logDataCount, setLogDataCount] = useState<number>(0);

  useEffect(() => {
    if (activeTab === "log") {
      const fetchLogs = async () => {
        try {
          setLoading(true);

          const reqBody = {
            search: debouncedSearch?.trim() || "",
            dateRange: {
              from: startDate ? startDate.toISOString().split("T")[0] : "",
              to: endDate ? endDate.toISOString().split("T")[0] : "",
            },
            page,
            limit,
          };

          const res = await getActivityLogs(reqBody, token);
          console.log('Activity logs response:', res.data.data);

          if (res?.data?.data && Array.isArray(res.data.data)) {
            // Map API response to LogEntry format
            const logs: LogEntry[] = res.data.data.map((item: any) => ({
              id: item.id ?? "-",
              pmi_entity_codes: item.pmi_entity_codes ?? "-",
              created_at: formatLogDate(item.updated_at), // ✅ format date
              type: item.file_name ?? "-",
              description: item.description ?? "-",
              original_file_name: item.original_file_name ?? "-",
            }));

            setLogData(logs);
            setLogDataCount(res.data.count || 0);
          }
        } catch (err) {
          console.error("Error fetching logs:", err);
          setLogData([]);
          setLogDataCount(0);
        } finally {
          setLoading(false);
        }
      };

      fetchLogs();
    }
  }, [activeTab, debouncedSearch, startDate, endDate, page]);

  console.log('logData state:', logData);
  // ✅ fetch data
  const fetchData = async () => {
    try {
      // setLoading(true);
      if (isBulk) {
        const reqBody: Record<string, any> = {
          search: debouncedSearch?.trim() || "",
          dateRange: {
            from: startDate ? startDate.toLocaleDateString("en-CA") : "",
            to: endDate ? endDate.toLocaleDateString("en-CA") : "",
          },
          page,
          limit
        };
        console.log('reqBody==========', reqBody)
        const res = await getSfaData(reqBody, token);
        console.log('sffffffffffaaaaaaaaa', res)
        if (res?.success && Array.isArray(res.data)) {
          setSfaData(
            res.data.map((item: any) => ({
              id: item.id ?? "-",
              pmi_entity_code: item.pmi_entity_code ?? "-",
              dte_contact_id: item.dte_contact_id ?? "-",
              createdAt: item.createdAt ?? "-",
              updatedAt: item.updatedAt ?? "-",
              target_month_year: formatLogDate1(item.target_month_year ?? "-"),
              actual_month_year: formatLogDate(item.actual_month_year ?? "-"),
              overall: item.overall ?? "-",
              "marlboro_red/target_marlboro_red": item["marlboro_red/target_marlboro_red"] ?? "-",
              "marlboro_gold/target_marlboro_gold": item["marlboro_gold/target_marlboro_gold"] ?? "-",
              "marlboro_gold_advance/target_marlboro_gold_advance": item["marlboro_gold_advance/target_marlboro_gold_advance"] ?? "-",
              "marlboro_fuse_beyond/target_marlboro_fuse_beyond": item["marlboro_fuse_beyond/target_marlboro_fuse_beyond"] ?? "-",
              "marlboro_clove_mix/target_marlboro_clove_mix": item["marlboro_clove_mix/target_marlboro_clove_mix"] ?? "-",
              "marlboro_vista_forest_fusion/target_marlboro_vista_forest_fusion": item["marlboro_vista_forest_fusion/target_marlboro_vista_forest_fusion"] ?? "-",
              "total_actual_vol/total_target_vol": item["total_actual_vol/total_target_vol"] ?? "-"
            }))
          );

          setTotalUsers(res.totalCount)
        };
        setTotalUsers(res?.totalCount || res?.data?.length || 0);

      } else {
        const reqBody: {
          page: string;
          limit: string;
          search: string;
          locations: string[];
          outlet_type: string[];
          lastLogin: string;
          startDate?: string;
          endDate?: string;
        } = {
          page: String(page),
          limit: String(limit),
          search: debouncedSearch?.trim() || "",
          locations: filters.locations || [],
          outlet_type: filters.outlet_type || [],
          lastLogin: "", // ✅ always present
        };

        if (filters.lastLogin) {
          // if lastLogin filter is applied → clear date range
          reqBody.lastLogin = filters.lastLogin;
          reqBody.startDate = "";
          reqBody.endDate = "";
        } else {
          // otherwise → send date range
          reqBody.lastLogin = "";
          reqBody.startDate = filters.startDate
            ? formatDate(filters.startDate)
            : startDate
              ? formatDate(startDate)
              : "";
          reqBody.endDate = filters.endDate
            ? formatDate(filters.endDate)
            : endDate
              ? formatDate(endDate)
              : "";
        }
        const res = await viewretailersv2(reqBody, token);
        if (res && res.data.data?.finaluser_tasks) {
          setRetailerData(
            res.data.data.finaluser_tasks.map((item: any) => ({
              userId: item.userId ?? "-",
              pmi_entity_code: item.pmi_entity_code ?? "-",
              Current_points: item.Current_points ?? "-",
              Tasks_given: item.Tasks_given ?? 0,
              Total_lifetime_points: item.Total_lifetime_points ?? 0,
              Total_Redeemed_Points: item.Total_Redeemed_Points ?? "-",
              Last_redeemption_date: item.Last_redeemption_date ?? "-",
              Current_active_tasks: item.Current_active_tasks ?? 0,
              Current_active_tasks_completed: item.Current_active_tasks_completed ?? 0,
              Tasks_completed: item.Tasks_completed ?? 0,
              retailer_name: item.retailer_name ?? "-",
              outlet_name: item.outlet_name ?? "-",
              locations: item.locations ?? "-",
              outlet_type: item.outlet_type ?? "-",
              member_Since: item.member_Since_time ?? "-",
              no_of_task: item.no_of_task ?? 0,
              remaining_points: item.remaining_points ?? 0,
              ["remaining_points/total_points"]: item["remaining_points/total_points"] ?? "-",
              phone_number: item.phone_number ?? "-",
              totalpoints: item.totalpoints ?? 0,
              last_login: item.last_login_time_ist ?? "-",
              asm_name: item.asm_name ?? "-",
              tse_name: item.tse_name ?? "-",
              territory_code: item.territory_code ?? "-",
              area_code: item.area_code ?? "-",
              outlet_salesforce_id: item.outlet_salesforce_id ?? "-",
              sfa_id: item.sfa_id ?? "-",
              contract_since: item.contract_since ?? "-",
              current_rental_value: item.current_rental_value ?? "-",
              region: item.region ?? '-',
              territory_id: item.code ?? '-',
              dte_retailer: item.dte_retailer ?? "-",
              top_retailer: item.top_retailer ?? "-",
              status: item.status
                ? item.status.charAt(0).toUpperCase() + item.status.slice(1).toLowerCase()
                : "-",
            }))
          );
          setTotalUsers(res.data.data.retalers_length);
        }
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    activeTab !== "log" && fetchData();
  }, [debouncedSearch, startDate, endDate, isBulk, page, filters]);

  // ✅ debounce search
  useEffect(() => {
    const handleDebounce = debounce((query: string) => setDebouncedSearch(query), 300);
    handleDebounce(searchQuery);
    return () => handleDebounce.cancel();
  }, [searchQuery]);
  useEffect(() => {
    const handleFiltersApplied = (event: any) => {
      setFilters(event.detail); // ✅ update parent state
      setPage(1); // reset to page 1 on filter change
    };

    window.addEventListener("filtersApplied", handleFiltersApplied);
    return () => window.removeEventListener("filtersApplied", handleFiltersApplied);
  }, []);

  // ✅ calculate popup position
  useEffect(() => {
    if (sortButtonRef.current && isPopupOpen) {
      const rect = sortButtonRef.current.getBoundingClientRect();
      setPopupPosition({
        top: rect.bottom + window.scrollY + 10,
        left: rect.right - 320,
      });
    }
  }, [isPopupOpen]);

  // ✅ close popup on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node) &&
        !sortButtonRef.current?.contains(event.target as Node)
      ) {
        setIsPopupOpen(false);
        const customEvent = new CustomEvent("filtersApplied", {
          detail: filters, // send current filters
        });
        window.dispatchEvent(customEvent);

      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [filters]);

  const fileInputRef = useRef<HTMLInputElement>(null);
  const [uploadType, setUploadType] = useState<"target" | "actual" | "rewards">("target");

  // NEW: local state for dropdown UI
  const [uploadChoice, setUploadChoice] = useState<string>("");

  // NEW: control Select open/close
  const [selectOpen, setSelectOpen] = useState(false);

  const handleUploadClick = (type: "target" | "actual" | "rewards") => {
    setUploadType(type);
    fileInputRef.current?.click();
  };

  // ✅ NEW: trigger file dialog during user gesture
  const pickUploadAndOpen = (v: "target" | "actual" | "rewards") => {
    setUploadType(v);
    setUploadChoice(v);
    setSelectOpen(false);
    // ensure it fires after closing but still in same gesture
    requestAnimationFrame(() => {
      fileInputRef.current?.click();
      setUploadChoice("");
    });
  };

  // Keep close as a no-op (no file click here)
  const handleSelectClose = () => {
    setSelectOpen(false);
  };

  console.log(uploadType, "uploadType===================");
  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const allowedExtensions = [".csv", ".xlsx"];
    const fileName = file.name.toLowerCase();
    const isValid = allowedExtensions.some(ext => fileName.endsWith(ext));

    if (!isValid) {
      showAlert("Only .csv and .xlsx files are allowed.", "error");
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    try {
      setLoading(true);
      let res;

      if (activeTab === "SFA") {
        if (uploadType === "target") {
          res = await uploadTargetSFA(file, token);
        } else if (uploadType === "actual") {
          res = await uploadActualSFA(file, token);
        } else {
          // rewards
          res = await uploadRewardsSFA(file, token);
        }
      } else {
        res = await uploadcsv(file);
      }

      if (res.data?.status === false) {
        showAlert("Failed to upload file.", "error");
      } else {
        // ✅ Custom success messages
        if (activeTab === "SFA") {
          if (uploadType === "target") {
            showAlert("Target file uploaded successfully.", "success");
          } else if (uploadType === "actual") {
            showAlert("Actual file uploaded successfully.", "success");
          } else {
            showAlert("Rewards file uploaded successfully.", "success");
          }
        } else {
          showAlert("CSV file uploaded successfully.", "success");
        }

        await fetchData();
      }
    } catch (err: any) {
      console.log(err, "error=========");
      const backendMessage =
        err.response?.data?.error ||
        err.response?.data?.message ||
        err.message ||
        "Error uploading CSV file.";

      showAlert(backendMessage, "error");
    } finally {
      setLoading(false);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  return (
    <Box sx={{ background: "#fff", paddingTop: "30px" }}>
      {/* Header */}
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(87, 87, 161, 0.2)", // ✅ lighter blue overlay
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={40} sx={{ color: "#0000FF" }} /> {/* ✅ smaller blue spinner */}
        </Box>
      )}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "0 32px",
          mb: 2,
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontSize: "24px",
            fontWeight: "600",
            color: "#000",
            marginLeft: "16px",
          }}
        >
          Bulk Upload
        </Typography>
        <ButtonGroup variant="outlined" sx={{ mr: 0 }}>
          {/* Retailers */}
          <Button
            onClick={() => {
              setActiveTab("retailer");
              localStorage.setItem("bulkTab", "retailer");
              console.log("Switched to Retailers tab");
              setSearchQuery("");
              setDebouncedSearch("");
              setDateRange([null, null]);
              setFilters({
                lastLogin: null,
                locations: [],
                outlet_type: [],
                startDate: null,
                endDate: null,
              });
              setPage(1);
            }}
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              bgcolor: activeTab === "retailer" ? "#C8172F" : "transparent",
              color: activeTab === "retailer" ? "#fff" : "#000",
              borderColor: "#C8172F",
              borderRadius: "8px",
              height: "40px",
              "&:hover": {
                bgcolor: activeTab === "retailer" ? "#a31425" : "rgba(200,23,47,0.1)",
                borderColor: "#a31425",
              },
            }}
          >
            Retailers
          </Button>

          {/* SFA */}
          <Button
            onClick={() => {
              setActiveTab("SFA");
              localStorage.setItem("bulkTab", "SFA");
              console.log("Switched to SFA tab");
              setSearchQuery("");
              setDebouncedSearch("");
              setDateRange([null, null]);
              setFilters({
                lastLogin: null,
                locations: [],
                outlet_type: [],
                startDate: null,
                endDate: null,
              });
              setPage(1);
            }}
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              bgcolor: activeTab === "SFA" ? "#C8172F" : "transparent",
              color: activeTab === "SFA" ? "#fff" : "#000",
              borderColor: "#C8172F",
              borderRadius: "8px",
              height: "40px",
              "&:hover": {
                bgcolor: activeTab === "SFA" ? "#a31425" : "rgba(200,23,47,0.1)",
                borderColor: "#a31425",
              },
            }}
          >
            TOP
          </Button>

          {/* Log */}
          <Button
            onClick={() => {
              setActiveTab("log");
              localStorage.setItem("bulkTab", "log");
              console.log("Switched to Log tab");
              setSearchQuery("");
              setDebouncedSearch("");
              setDateRange([null, null]);
              setFilters({
                lastLogin: null,
                locations: [],
                outlet_type: [],
                startDate: null,
                endDate: null,
              });
              setPage(1);
            }}
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              bgcolor: activeTab === "log" ? "#C8172F" : "transparent",
              color: activeTab === "log" ? "#fff" : "#000",
              borderColor: "#C8172F",
              borderRadius: "8px",
              height: "40px",
              "&:hover": {
                bgcolor: activeTab === "log" ? "#a31425" : "rgba(200,23,47,0.1)",
                borderColor: "#a31425",
              },
            }}
          >
            Logs
          </Button>
        </ButtonGroup>
      </Box>

      {/* Search + Upload + Date */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "16px",
          padding: "0 32px 30px",
        }}
      >
        {/* Search */}
        <Box sx={{ maxWidth: "520px", height: "48px", flexGrow: 1, }}>
          <TextField
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder={isBulk ? "PMI Entity Code, Description " : "Search by PMI Entity Code, Description"}
            type="search"
            variant="outlined"
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search sx={{ height: "20px", width: "20px" }} />
                </InputAdornment>
              ),
            }}
            sx={{
              width: "100%",
              height: "48px",
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                height: "48px",
                "& fieldset": { border: "1px solid #ccccccff", },
              },
            }}
          />
        </Box>

        {/* Upload + Date Picker */}
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
          <Box sx={{ display: "flex" }}>
            {isBulk ? (
              <Box> </Box>
            ) : (
              <Tooltip
                title={
                  <Box sx={{ fontSize: "14px", lineHeight: "1.6" }}>
                    <Typography variant="subtitle2">📂 Upload sequence:</Typography>
                    <Typography variant="body2">1️⃣ Contacts</Typography>
                    <Typography variant="body2">2️⃣ Accounts</Typography>
                    <Typography variant="body2">3️⃣ Account_Contacts</Typography>
                    <Typography variant="body2">4️⃣ Account_Territories</Typography>
                  </Box>
                }
                arrow
                slotProps={{
                  tooltip: {
                    sx: {
                      bgcolor: "grey.800",
                      fontSize: "14px",
                      p: 1.5,
                    },
                  },
                  arrow: {
                    sx: { color: "grey.800" },
                  },
                }}
                PopperProps={{
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, 0],
                      },
                    },
                  ],
                }}
              >
                <IconButton
                  disableRipple
                  sx={{
                    position: "relative",
                    top: "-6px",
                    "&:hover": { backgroundColor: "transparent" },
                  }}
                >
                  <Info />
                </IconButton>
              </Tooltip>
            )}

            {/* ▼ Upload Type Dropdown */}
            {(activeTab === "SFA" || activeTab === "retailer") && (
              <FormControl
                size="small"
                sx={{
                  minWidth: 220,
                  mr: 0,
                  mb: 2,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                  },
                }}
              >
                <Select
                  displayEmpty
                  open={selectOpen}
                  onOpen={() => setSelectOpen(true)}
                  onClose={handleSelectClose}
                  value={uploadChoice}
                  onChange={() => { /* no-op; we use MenuItem onMouseDown */ }}
                  renderValue={(selected) => {
                    if (!selected) {
                      return activeTab === "SFA" ? "Choose upload type" : "Choose CSV upload";
                    }
                    const map: Record<string, string> = {
                      target: "Target Upload",
                      rewards: "Rewards Upload",
                      actual: activeTab === "SFA" ? "Actual Upload" : "CSV Upload",
                    };
                    return map[selected] || "Choose upload type";
                  }}
                  MenuProps={{ disablePortal: true }}
                  /** 👇 Use the CustomArrow here */
                  IconComponent={() => (
                    <CustomArrow open={selectOpen} onClick={() => setSelectOpen(!selectOpen)} />
                  )}
                  sx={{
                    backgroundColor: "#fff",
                    "& .MuiSelect-select": {
                      paddingRight: "36px", // room for the custom arrow
                    },
                  }}
                >
                  {activeTab === "SFA" ? (
                    <>
                      <MenuItem
                        value="target"
                        onMouseDown={() => pickUploadAndOpen("target")}
                      >
                        Target Upload
                      </MenuItem>
                      <MenuItem
                        value="rewards"
                        onMouseDown={() => pickUploadAndOpen("rewards")}
                      >
                        Rewards Upload
                      </MenuItem>
                      <MenuItem
                        value="actual"
                        onMouseDown={() => pickUploadAndOpen("actual")}
                      >
                        Actual Upload
                      </MenuItem>
                    </>
                  ) : (
                    <MenuItem
                      value="actual"
                      onMouseDown={() => pickUploadAndOpen("actual")}
                    >
                      CSV Upload
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            )}

            <input
              type="file"
              accept=".csv,.xlsx"
              ref={fileInputRef}
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
          </Box>

          <Box sx={{ width: "301px" }}>
            <DatePicker
              selectsRange
              startDate={startDate || undefined}
              endDate={endDate || undefined}
              onChange={(update) => {
                if (Array.isArray(update)) {
                  const [start, end] = update;
                  setDateRange([start, end])
                }
              }}
              customInput={
                <CustomInput
                  onClear={() => {
                    setDateRange([null, null]);
                    // reset filters as needed
                    const event = new CustomEvent("filtersApplied", {
                      detail: { ...filters, startDate: null, endDate: null },
                    });
                    window.dispatchEvent(event);
                  }}
                />
              }
              renderCustomHeader={({
                date,
                decreaseMonth,
                increaseMonth,
                decreaseYear,
                increaseYear,
              }) => (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button onClick={decreaseYear}>
                    <img src={doubleArrowLeft} alt="arrowleft" />
                  </button>

                  {/* Year Arrow */}
                  <button onClick={decreaseMonth}>
                    <img src={arrowLeft} alt="arrowleft" />
                  </button>
                  {/* Month Arrow */}
                  <span style={{ margin: "0 10px" }}>
                    {date.toLocaleString("default", {
                      year: "numeric",
                      month: "long",
                    })}
                  </span>
                  {/* Current Month and Year */}
                  <button onClick={increaseMonth}>
                    <img src={arrowRight} alt="arrow left" />
                  </button>
                  {/* Month Arrow */}
                  <button onClick={increaseYear}>
                    <img src={doubleArrowRight} alt="double arrow" />
                  </button>
                  {/* Year Arrow */}
                </div>
              )}
            />
          </Box>
        </Box>
      </Box>

      {/* Sort Popup */}
      {isPopupOpen && (
        <Box
          ref={popupRef}
          sx={{
            position: "absolute",
            top: `${popupPosition.top}px`,
            left: `${popupPosition.left}px`,
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px 0",
            zIndex: 999,
            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            width: "320px",
          }}
        >
          <List>
            {[{ label: "Highest to Lowest Points", value: "highest" }, { label: "Lowest to Highest Points", value: "lowest" }].map(({ label, value }) => (
              <ListItemButton key={value} onClick={() => setIsPopupOpen(false)}>
                <ListItemText primary={label} />
              </ListItemButton>
            ))}
          </List>
        </Box>
      )}

      {/* Table */}
      <Box
        sx={{
          width: "100%",
          background: "#f9fbfc",
          padding: "20px 30px",
          borderTop: "1px solid #d3d3d3",
        }}
      >
        {activeTab === "SFA" ? (
          <BulkSFATable
            data={sfaData}
            loading={loading}
            page={page}
            limit={limit}
            totalRecords={totalUsers}
            search={debouncedSearch}
            startDate={startDate}
            endDate={endDate}
            setPage={setPage}
          />
        ) : activeTab === "retailer" ? (
          <BulkRetailerTable
            data={retailerData}
            totalUsers={totalUsers}
            page={page}
            search={debouncedSearch}
            setPage={setPage}
            startDate={formatDate(startDate)}
            endDate={formatDate(endDate)}
            limit={limit}
          />
        ) : (
          <LogTable
            data={logData} // ✅ dynamic logs from API
            page={page} // ✅ use same page state
            limit={limit} // ✅ same limit as other tables
            totalUsers={logDataCount} // ✅ total rows
            search={debouncedSearch} // ✅ optionally allow search
            startDate={startDate} // ✅ filter by startDate
            endDate={endDate} // ✅ filter by endDate
            setPage={setPage} // ✅ pagination handler
          />
        )}
      </Box>

    </Box>
  );
}

// ✅ Inline CSS for alerts
const styles = `
  .alert-success {
    background-color: #4caf50; /* Green */
    color: #fff;
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    margin: 10px 0;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  }
  .alert-error {
    background-color: #f44336; /* Red */
    color: #fff;
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    margin: 10px 0;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  }
`;

// ✅ Inject styles into the page
if (typeof document !== "undefined") {
  const styleTag = document.createElement("style");
  styleTag.innerHTML = styles;
  document.head.appendChild(styleTag);
}
export default BulkUploads;